/**
 * `/auth/signed-out` — the confirmation landing after an explicit sign-out, or after a password
 * change (which signs the member out everywhere — H §4.6; navigated here with
 * `state.passwordChanged`). Offers a route back to centralized login.
 */
import { useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { SkipLink } from '@/components/SkipLink';
import { redirectToCentralizedLogin } from '@/auth/silentRefresh';
import { HOME_PATH } from '@/routes/home';

export function SignedOut() {
  const { t } = useTranslation();
  const location = useLocation();
  const passwordChanged =
    (location.state as { passwordChanged?: unknown } | null)?.passwordChanged === true;
  return (
    <>
      <SkipLink />
      <main
        id="main"
        tabIndex={-1}
        style={{ padding: '2rem', maxWidth: '32rem', margin: '0 auto' }}
      >
        <h1>{passwordChanged ? t('auth.passwordChangedTitle') : t('auth.signedOutTitle')}</h1>
        <p>{passwordChanged ? t('auth.passwordChangedBody') : t('auth.signedOutBody')}</p>
        <button type="button" onClick={() => redirectToCentralizedLogin(HOME_PATH)}>
          {t('auth.signInAgain')}
        </button>
      </main>
    </>
  );
}
